import { gql } from '@apollo/client'

export default gql(`
    mutation($resolutions: [CreateResolutionsInput]!) {
        createResolutions(input: $resolutions ) {
            width
            height
            id
          }
    }`
)
